import axios from 'api/axios'
import { ClientProfile } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * API call to convert a trial (DEMO) client to live mode.
 * @param id - client id
 * @returns Updated ClientProfile
 */
export const convertTrialToLive = async (id: string) => {
	try {
		const { data } = await axios.patch<ClientProfile>(
			`client/trial/convert-to-live/${id}`
		)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default convertTrialToLive
